import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IHypotheekdeel } from '@/model/IHypotheekdeel';
import { required } from 'vuelidate/lib/validators';
import { tjipMinValue, tjipMaxValue, TjipFormGroupCurrencyComponent } from '@tjip/vuejs';

@Component({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  validations: AppAflossenHypotheekdeelEdit.validations
})
export default class AppAflossenHypotheekdeelEdit extends Mixins(AppFiltersMixin) {
  private static validations(this: AppAflossenHypotheekdeelEdit) {
    return {
      internalValue: {
        required,
        minValue: tjipMinValue(1),
        maxValue: tjipMaxValue(this.maxAllowedAflossing)
      }
    };
  }

  @Prop({ required: true })
  public value!: any;
  @Prop()
  public hypotheekdeel!: IHypotheekdeel;
  @Ref('ctrl')
  public ctrl!: TjipFormGroupCurrencyComponent;
  public maxIdealTransactionAmount = 50000;

  public get internalValue(): any {
    return this.value;
  }

  public set internalValue(value: any) {
    if (value !== this.value) {
      this.$emit('input', value);
    }
  }

  public get maxAflossing(): number {
    return Math.min(
      this.hypotheekdeel.aflossingZonderVergoedingPerJaar,
      this.hypotheekdeel.aflossingZonderVergoedingSaldo
    );
  }

  public get maxAllowedAflossing(): number {
    return Math.min(this.maxIdealTransactionAmount, this.maxAflossing);
  }

  public get isIdealLimit(): boolean {
    return this.maxAflossing > this.maxIdealTransactionAmount;
  }

  public touch() {
    this.ctrl.$v.$touch();
    this.ctrl.control.$v.$touch();
  }

  public reset() {
    this.ctrl.$v.$reset();
    this.ctrl.control.$v.$reset();
  }
}
